import type { PolicyLink } from '../services/types'
import { parseDdMmYyyyToDate } from './dobDateInput'

function localCalendarDayStart(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
}

/**
 * Policy term / cover start as a local calendar day from Entsia ISO fields on {@link PolicyLink}.
 * Uses the date part of `coverStartDate`, falling back to `termStartDate`.
 */
export function parsePolicyCoverStartLocalDay(policy: PolicyLink | null | undefined): Date | null {
  if (!policy) return null
  const raw = (policy.coverStartDate ?? policy.termStartDate)?.trim()
  if (!raw) return null
  const dayPart = raw.slice(0, 10)
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dayPart)
  if (!m) return null
  const y = parseInt(m[1], 10)
  const mo = parseInt(m[2], 10)
  const d = parseInt(m[3], 10)
  const dt = new Date(y, mo - 1, d)
  if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null
  return dt
}

/**
 * True when `incidentDdMmYyyy` is a complete valid calendar date strictly before the policy cover start day.
 */
export function isIncidentDdMmYyyyBeforePolicyStart(
  incidentDdMmYyyy: string,
  policy: PolicyLink | null | undefined
): boolean {
  const policyStart = parsePolicyCoverStartLocalDay(policy)
  if (!policyStart) return false
  const inc = parseDdMmYyyyToDate(incidentDdMmYyyy.trim())
  if (!inc) return false
  return localCalendarDayStart(inc) < localCalendarDayStart(policyStart)
}
